// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dphZ9q7-pQU0NG {\n  margin-bottom: 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamTypeSelect": "dphZ9q7-pQU0NG"
};
export default ___CSS_LOADER_EXPORT___;
